import clsx from "clsx";
import { PiImageSquareBold } from "react-icons/pi";
import type { ListingDetailed } from "../../interfaces/listing";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface BrowseListingSliderProps {
  setOverlayOpen: (listing: boolean) => void;
  listing: ListingDetailed | null;
}
const BrowseListingSlider = ({
  setOverlayOpen,
  listing,
}: BrowseListingSliderProps) => {
  return (
    <div className="h-[500px] max-h-[500px] relative">
      <div className="grid grid-cols-4 grid-rows-2 gap-2 h-full">
        {listing?.images.slice(0, 5).map((item, itemIndex) => (
          // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
          <div
            onClick={() => setOverlayOpen(true)}
            key={itemIndex}
            className={clsx(
              "rounded-[10px] overflow-hidden w-full h-full relative cursor-pointer",
              itemIndex === 0 && "col-span-2 row-span-2"
            )}
          >
            {itemIndex === 4 && (
              <div className="flex items-center text-white space-x-2 text-2xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                <PiImageSquareBold className="text-3xl" />
                <span className="font-bold">{listing?.images.length}</span>
              </div>
            )}
            <img
              className={clsx(
                "h-full w-full absolute inset-0 object-cover",
                itemIndex === 4 && "blur-[7px]"
              )}
              src={item}
              alt={`Slide ${itemIndex + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { BrowseListingSlider };
